import React, { useState } from "react";
import { Alert, Button, TextField, MenuItem } from "@mui/material";
import { Tag, Plus } from "lucide-react";
import ArticleCompanyUnits from "./ArticleCompanyUnits";
import { createPriceRows } from "./articlePriceOption";

export default function ArticlePriceOptionDialog({ units, companyUnits, initialBarcode, details, onClose, onAdd, validateBarcode }) {
  const [option, setOption] = useState({ newBarcode: initialBarcode, typeOfSales: 2, articleUnitID: "", articleUnitQty: "", newSalesPrice: "" });
  const [selected, setSelected] = useState([]);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const field = key => ({ value: option[key], onChange: e => {
    const value = e.target.value;
    setOption(prev => ({ ...prev, [key]: value,
      ...(key === "typeOfSales" ? { articleUnitQty: Number(value) === 2 ? "" : 1 } : {}),
    }));
  } });
  const add = async () => {
    setError("");
    setBusy(true);
    try {
      const rows = createPriceRows(option, selected, details);
      await validateBarcode(rows[0].newBarcode);
      onAdd(rows);
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  };
  return <div className="article-price-inline" role="region" aria-label="Çmim tjetër">
      <div className="article-price-inline__heading">
        <span className="article-price-inline__icon"><Tag size={18} aria-hidden="true" /></span>
        <div><strong>Çmim shtesë</strong><span>I njëjti çmim për njësitë që zgjidhni</span></div>
      </div>
      <div className="article-price-inline__fields">
        <TextField fullWidth InputLabelProps={{ shrink: true }} size="small" select label="Lloji i shitjes" {...field("typeOfSales")} disabled={busy}><MenuItem value={1}>Pakicë</MenuItem><MenuItem value={2}>Shumicë</MenuItem></TextField>
        <TextField fullWidth InputLabelProps={{ shrink: true }} size="small" select SelectProps={{ MenuProps: {
          PaperProps: { sx: { maxHeight: 'min(280px, 50vh)', maxWidth: 'calc(100vw - 32px)', overflowY: 'auto', '& .MuiMenuItem-root': { minHeight: 36, whiteSpace: 'normal', overflowWrap: 'anywhere', fontSize: 14 } } },
          MenuListProps: { dense: true },
        } }} label="Njësia e artikullit" {...field("articleUnitID")} disabled={busy}>{units.map(unit => <MenuItem key={unit.UnitID} value={unit.UnitID}>{unit.UnitName}</MenuItem>)}</TextField>
        <TextField fullWidth InputLabelProps={{ shrink: true }} size="small" label="Barkodi i këtij paketimi" {...field("newBarcode")} disabled={busy} />
        <TextField fullWidth InputLabelProps={{ shrink: true }} size="small" label="Sasia në paketim" placeholder="Shënoni sasinë" type="number" inputProps={{ min: 0.0001, step: "any", "aria-required": Number(option.typeOfSales) === 2 }} {...field("articleUnitQty")} disabled={busy} />
        <TextField className="article-price-inline__price" fullWidth InputLabelProps={{ shrink: true }} size="small" label="Çmimi i shitjes me TVSH (€)" type="number" inputProps={{ min: 0, step: "any" }} {...field("newSalesPrice")} disabled={busy} />
      </div>
      <div className="article-price-inline__units">
      <ArticleCompanyUnits units={companyUnits} details={selected.map(companyUnitId => ({ companyUnitId }))} disabled={busy}
        onToggle={(id, checked) => setSelected(prev => checked ? [...prev, Number(id)] : prev.filter(value => value !== Number(id)))} />
      </div>
      {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
    <div className="article-price-inline__actions"><Button type="button" size="small" onClick={onClose} disabled={busy}>Anulo</Button><Button type="button" size="small" variant="contained" disableElevation startIcon={<Plus size={16} />} onClick={add} disabled={busy}>{busy ? "Duke kontrolluar…" : "Shto në tabelë"}</Button></div>
  </div>;
}
